import { Record } from 'immutable';
import Network from '../utils/network';

const api = Network();

class User extends Record({
    id: null,
    first_name: '',
    last_name: '',
    email: '',
    username: '',
    password: ''
  }) {
    $create() {
      return api.post({
        resource: 'users'
      }, this);
    }

    $get(id) {
      if (!id) id = this.id;

      return api.get({
        resource: '/users/' + id
      });
    }

    $login() {
      return api.post({
        resource: 'auth_tokens'
      }, this);
    }

    $update(id) {
      if (!id) id = this.id;

      return api.patch({
        resource: '/users/' + id
      }, this)
    }
  }

export default User;



// WEBPACK FOOTER //
// ./src/records/user.js